/** @module Camunda/TaskDefinitionInfoRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/LocalizedTextarea"
], function(declare,LocalizedTextarea) {

	return declare(LocalizedTextarea, {
		useSiteLocale: true,
		
		/**
		 * @override
		 * Don't show tooltip on Info (aka Description) property
		 */
		toTooltip: function(ctx, h, tooltip) {
			return;
		}
	});
});